// src/components/Footer.jsx
import "./footer.scss";

// Using Bootstrap icons CDN
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const LAUNCHPAD_ROOT_HOSTS = new Set(["gbob.fun", "www.gbob.fun"]);

export default function Footer() {
  const location = useLocation();
  const path = String(location?.pathname || "").toLowerCase();
  const host = typeof window !== "undefined" ? String(window.location.hostname || "").toLowerCase() : "";
  const isLaunchpadRoute = LAUNCHPAD_ROOT_HOSTS.has(host) || path.startsWith("/launchpad");

  // Load Bootstrap Icons CDN once
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
    document.head.appendChild(link);
  }, []);

  return (
    <footer id="site-footer">
      <div className="footer-container">
        {/* --- Social Icons Row --- */}
        <div className="footer-social">
          <a
            href="https://x.com/bobmonad"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon twitter"
          >
            <i className="bi bi-twitter"></i>
          </a>

          <a
            href="https://t.me/+cHY1yu1-tVtiYWNh"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon telegram"
          >
            <i className="bi bi-telegram"></i>
          </a>

          <a
            href="https://discord.gg/c69kaPBcav"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon discord"
          >
            <i className="bi bi-discord"></i>
          </a>
        </div>

        {/* --- Disclaimer --- */}
        <p className="footer-disclaimer">
          {isLaunchpadRoute
            ? "gBob Launchpad is a self-serve token presale interface. Presales, participation, refunds, claims, and launches are executed through smart contracts, and users should review each project carefully before taking part."
            : "This is a community-driven meme coin with no intrinsic value, promises, or expectations of profit. Participate only at your own risk; nothing here is financial advice or an investment offering."}
        </p>

        {/* --- Copyright --- */}
        <p className="footer-copy">
          Copyright {new Date().getFullYear()} Bob. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
